import { FC } from 'react';
import { BusinessPageLayout } from '../components/BusinessPageLayout/BusinessPageLayout';

export const BusinessPage: FC = () => {
  return <BusinessPageLayout testID="page-business-select" />;
};
